import PrequalQuestionsSetCtrl from 'gw-portals-questionsets-angular/PrequalQuestionsSetCtrl';

class PAPrequalQuestionsCtrl extends PrequalQuestionsSetCtrl {

    constructor($scope, submissionViewModel, MetadataDrivenUIService, LOCALE_CHANGE_EVENT_NAME) {
        super($scope, submissionViewModel, MetadataDrivenUIService, LOCALE_CHANGE_EVENT_NAME, 'pa');
        this._init();
    }
    
}

PAPrequalQuestionsCtrl.$inject = ['$scope', 'submissionViewModel', 'MetadataDrivenUIService', 'LOCALE_CHANGE_EVENT_NAME'];

export default PAPrequalQuestionsCtrl;